(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  async function attemptFetch(url, attempts = 3, status = {}) {
    if (attempts === 0) {
      console.error('Error on product recommendations (fetching): ', status.code, status.text);
      return false;
    }
    const promise = await fetch(url);
    if (!promise.ok) return await attemptFetch(url, attempts - 1, { code: promise.status, text: promise.statusText });
    return promise;
  }

  async function renderProductRecommendations(container) {
    const promise = await attemptFetch(container.dataset.url);
    if (!promise) return;
    const data = await promise.text();
    if (data == 404) {
      console.error('Error on product recommendations (product or section not found): ', data);
      return;
    }
    if (data == 422) {
      console.error('Error on product recommendations (invalid request parameter): ', data);
      return;
    }
    const html = document.createElement('div');
    html.innerHTML = data;
    const recommendationsList = container.querySelector("[data-recommendations='list']");
    const recommendationsProducts = html.querySelectorAll("[data-recommendations='product']");
    if (recommendationsProducts && recommendationsProducts.length) {
      recommendationsProducts.forEach((product) => {
        recommendationsList.appendChild(product);
      });
      const settings = getSlickSettings();
      $("[data-recommendations='list']").slick(settings);
      $(window).resize(function () {
        resizeRecommendationsSlider("[data-recommendations='list']");
      });
    } else {
      container.parentElement.parentElement.removeChild(container.parentElement);
    }
  }

  function getSlickSettings() {
    return {
      mobileFirst: true,
      autoplay: true,
      autoplaySpeed: 4000,
      swipe: true,
      dots: false,
      arrows: false,
      infinite: true,
      speed: 600,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDots: false,
      cssEase: 'ease-in-out',
      centerMode: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: 'unslick',
        },
      ],
    };
  }

  function resizeRecommendationsSlider(selector) {
    $selector = $(selector);
    if ($(window).width() >= 480) {
      if ($selector.hasClass('slick-initialized')) $selector.slick('unslick');
      return;
    }
    if (!$selector.hasClass('slick-initialized')) return $selector.slick(getSlickSettings());
  }

  const recommendationsContainer = document.querySelector("[data-recommendations='container']");
  renderProductRecommendations(recommendationsContainer);

  } catch(e) { console.error(e); }
})();
})();
